import React from 'react';
import useStyles from "./Dashboard.style";
import {
    Container,
    Grid,
    Typography
} from "@mui/material";
import {generateHelmet} from "../../utils/helperFunctions";
import Header from "../../components/General/Header/Header";

function LoyaltyProgram() {
    const classes = useStyles();
    return (
        <>
            { generateHelmet('Program lojalnościowy', 'Profil lojalnościowy w aplikacji hullo') }
            <Header/>
            <main>
                <section>
                    <Container>
                        <Grid container spacing={3}>
                            <Grid item lg={12} xs={12}>
                                <Typography component="h1">
                                    LoyaltyProgram
                                </Typography>
                            </Grid>
                        </Grid>
                    </Container>
                </section>
            </main>
        </>
    );
}

export default LoyaltyProgram;